var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tip',{directives:[{name:"show",rawName:"v-show",value:(_vm.tip_flag),expression:"tip_flag"}]}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }